<template>
  <div class="originSearch">
    <input
        class="search-box"
        placeholder="something.examus.net"
        @keydown.enter="goToOrigin"
        type="text">
  </div>
</template>

<script>

export default {
  name: 'originSearch',
  methods: {
    goToOrigin (e) {
      let origin = e.target.value.trim()

      if (origin) {
        this.$router.push(
          {path: `/origin/${origin}`})
      }
    }
  }
}
</script>

<style scoped>

</style>
